import { HttpClient } from '@angular/common/http';
import { environment } from './../../../../environments/environment';
import { Injectable } from '@angular/core';
import { RequestRecord } from '../../../shared/models/request-round/request-record.interface';

@Injectable({
  providedIn: 'root'
})
export class RequestRecordService {

  private baseUrl = environment.baseURL;

  constructor(private http: HttpClient) { }

  getAllRequestRecords(requestId: number) {
    return this.http.get<RequestRecord[]>(`${this.baseUrl}/request-service-records/request/${requestId}`);
  }

  getSingleRecord(recordId: number) {
    return this.http.get<RequestRecord>(`${this.baseUrl}/request-service-records/${recordId}`);
  }

  createRecord(record: RequestRecord) {
    return this.http.post<RequestRecord>(`${this.baseUrl}/request-service-records`, record);
  }

  updateRecord(recordId: string, record: RequestRecord) {
    return this.http.put<RequestRecord>(`${this.baseUrl}/request-service-records/${recordId}`, record);
  }

  deleteRecord(recordId: string) {
    return this.http.delete<RequestRecord>(`${this.baseUrl}/request-service-records/${recordId}`);
  }

  savePaymentRoundLink(recordId:string, paymentLink:string){
    let body = {
      paymentLink: paymentLink
    }
    return this.http.put<RequestRecord>(`${this.baseUrl}/request-service-records/${recordId}/payment`, body)
  }
}
